export default {
  // cover
  methods: {
    getCoverImage(screenWidth, coverFeatured ) {
      // const mediaQuery = window.matchMedia('(orientation: landscape)')
      // if (mediaQuery.matches) {
      //   return coverFeatured.replace("{sizeId}", 1).replace("{scale}", 1);
      // }

      if (screenWidth > 1018) {
        return coverFeatured.replace("{sizeId}", 0).replace("{scale}", 1);
      } else {
        return coverFeatured.replace("{sizeId}", 3).replace("{scale}", 1);
      }

    },
    replaceCoverImage(image) {
      return image.replace("{sizeId}", 0).replace("{scale}", 1);
    },
    replaceCoverImageIsMobile(image) {
      return image.replace("{sizeId}", 2).replace("{scale}", 2);
    },

    replacePreloadCoverImage(screenWidth, image) {
      if (screenWidth > 1279) {
        return image.replace("{sizeId}", 3).replace("{scale}", 1);
      } else if ((screenWidth > 414) && (screenWidth < 1279)) {
        return image.replace("{sizeId}", 2).replace("{scale}", 1);
      } else {
        return image.replace("{sizeId}", 1).replace("{scale}", 1);
      } 
    },
    replaceBigCoverImage(image) {
      return image.replace("{sizeId}", 4).replace("{scale}", 1);
    },

    generateRouteUrl(item) {
      if (item.contentType === "Serial") {
        return (
          "/" + item.contentType.toLowerCase() + "s/" + item.id + "/episode/0"
        );
      }
      return "/" + item.contentType.toLowerCase() + "s/" + item.id;
    },

    generateRouteUrlToAudio(albumId) {
      return `/albums/${albumId}`;
    },
  },
};
